//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";

export const Medication = createAsyncThunk(
  "Medication",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingMedication(""));
      const response = await UsePortalApi(
        `Patient/Medication`,
        "Post",
        payload,
        true
      );
      if (response) {
        console.log(response , "response")
        response[0].hasOwnProperty('entry') ? dispatch(gettingMedicationSuccess(response[0].entry)) : dispatch(gettingMedicationClear())

      } else {
        dispatch(
          gettingMedicationFailed(
            response?.errorMessage
          )
        );
      }
    } catch (error) {
      dispatch(gettingMedicationFailed(error));
    }
  }
);
const MedicationSlice = createSlice({
  name: "Medication",
  initialState: {
    AllMedeications: null,
    isGetting: false,
    error: false,
  },
  reducers: {
    gettingMedication: (state, action) => {
      state.AllMedeications = null;
      state.isGetting = true;
      state.error = false;
    },
    gettingMedicationSuccess: (state, action) => {
      state.AllMedeications = action.payload;
      state.isGetting = false;
      state.error = false;
    },
    gettingMedicationFailed: (state, action) => {
      state.AllMedeications = null;
      state.isGetting = false;
      state.error = true;
    },
    gettingMedicationClear: (state, action) => {
      state.AllMedeications = null;
      state.isGetting = false;
      state.error = false;
    },
  },
});
export const {
  gettingMedication,
  gettingMedicationSuccess,
  gettingMedicationFailed,
  gettingMedicationClear,
} = MedicationSlice.actions;
export default MedicationSlice.reducer;
